import { render, staticRenderFns } from "./game.vue?vue&type=template&id=e83d9b0a"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports